import React, { useCallback, useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet-async";
import { Link, useLocation } from "react-router-dom";
import { ErrorToast } from "../../../Utils/SweetAlert";
import { useQuery } from "@tanstack/react-query";
import { GetSingleWelfare } from "../../../Api/welfare";
import noImage from "../../../assets/Images/no-image.png"
import BackButton from "../../../Components/BackButton";

const WelfareDetail = () => {
  const stateData = useLocation();

  const { id } = stateData?.state || "";

  const { data } = useQuery({
    queryKey: ["get-single-product"],
    queryFn: () => GetSingleWelfare({ id: id }),
    throwOnError: (error) => {
      ErrorToast(error?.response?.data?.message || "Server error.");
    },
  });

  const handleImageError = (event) => {
    event.target.src = noImage;
  };

  const sections = data?.data?.section || [];

  return (
    <>
      <Helmet>
        <title>OVE | Admin Welfare Detail</title>
      </Helmet>
      <div className="page-wrapper welfare">
        <div className="content container-fluid">
          <div className="admin-wrapper">
            {/* Page Header */}
            <div className="page-header">
              <div className="col">
                <h1 className="page-title">Welfare Detail</h1>
              </div>
              <div className="col-auto">
                <BackButton to="/admin/welfare-listing" />
              </div>
            </div>

            {/* Main Content */}
            <div className="col-sm-12">
              <div className="cards-table card-table">
                <div className="card-body">
                  {/* Welfare Overview Section */}
                  <div className="row">
                    <div className="col-md-6">
                      <div className="row">
                        <div className="col-12">
                          <label className="sub-title fs-4">Name</label>
                          <p className="d-block modal-value">
                            {data?.data?.name || "-"}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Sections */}
                  {sections?.length > 0 && (
                    <>
                      <h4 className="sub-title mb-3 fs-4">Sections</h4>
                      <div className="row">
                        {sections?.map((sectionData, sectionIndex) => (
                          <div key={sectionIndex} className="col-12 mb-4">
                            <div className="welfare-section-card">
                              <div className="row">
                                <div className="col-md-4 col-xl-4 col-lg-4 d-block">
                                  <label className="d-block modal-label">Logo</label>
                                  <img
                                    src={sectionData?.logo_url}
                                    alt={sectionData?.name}
                                    className="section-logo"
                                    onError={handleImageError}
                                    style={{ cursor: "pointer", maxWidth: "100px" }}
                                  />
                                </div>
                                <div className="col-md-4 col-xl-4 col-lg-4 d-block">
                                  <label className="d-block modal-label">Name</label>
                                  <span className="d-block modal-value">
                                    {sectionData?.name || "-"}
                                  </span>
                                </div>
                                <div className="col-md-4 col-xl-4 col-lg-4 d-block">
                                  <label className="d-block modal-label">Phone Number</label>
                                  <span className="d-block modal-value">
                                    {sectionData?.phoneNumber || "-"}
                                  </span>
                                </div>
                              </div>
                              <div className="row mt-3">
                                <div className="col-md-4 col-xl-4 col-lg-4 d-block">
                                  <label className="d-block modal-label">Helpline Number</label>
                                  <span className="d-block modal-value">
                                    {sectionData?.helplineNumber || "-"}
                                  </span>
                                </div>
                                <div className="col-md-4 col-xl-4 col-lg-4 d-block">
                                  <label className="d-block modal-label">Description</label>
                                  <span className="d-block modal-value">
                                    {sectionData?.description || "-"}
                                  </span>
                                </div>
                                <div className="col-md-4 col-xl-4 col-lg-4 d-block">
                                  <label className="d-block modal-label">Website</label>
                                  <span className="d-block modal-value">
                                    {sectionData?.website || "-"}
                                  </span>
                                </div>
                              </div>
                              <div className="row mt-3">
                                <div className="col-md-4 col-xl-4 col-lg-4 d-block">
                                  <label className="d-block modal-label">Opening Hours</label>
                                  <span className="d-block modal-value">
                                    {sectionData?.openingHours || "-"}
                                  </span>
                                </div>
                                <div className="col-md-4 col-xl-4 col-lg-4 d-block">
                                  <label className="d-block modal-label">Live Help Chat Link</label>
                                  <span className="d-block modal-value">
                                    {sectionData?.liveHelpChatLink || "-"}
                                  </span>
                                </div>
                                <div className="col-md-4 col-xl-4 col-lg-4 d-block">
                                  <label className="d-block modal-label">Live Help Chat Description</label>
                                  <span className="d-block modal-value">
                                    {sectionData?.liveHelpChatDescription || "-"}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WelfareDetail;
